import { Button, FormLayout, SubmitButton, TextInput } from '@expressable/syntax-ds';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useRequestResetPasswordFormContext } from '../context';

type Props = {
  isLoading: boolean;
};

export const FormUi = ({ isLoading }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { register } = useFormContext();

  const { onBack } = useRequestResetPasswordFormContext();

  return (
    <>
      <FormLayout.Fields>
        <TextInput
          {...register('username')}
          data-testid="form-forgot-password-email"
          autoFocus
          label={t('login.form.fields.email')}
        />
      </FormLayout.Fields>

      <FormLayout.GlobalErrors message={t('intake.form.validationErrors')} />

      <FormLayout.CTA column>
        <SubmitButton data-testid="form-send-code-button" size="lg" fullWidth>
          {t('login.passwordReset.sendCode')}
        </SubmitButton>
        {!onBack && (
          <Link to="/">
            <Button data-testid="form-return-log-in-button" disabled={isLoading} variant="link" size="lg" fullWidth>
              {t('login.passwordReset.returnToLogin')}
            </Button>
          </Link>
        )}

        {onBack && (
          <Button
            data-testid="form-return-log-in-button"
            disabled={isLoading}
            variant="link"
            size="lg"
            fullWidth
            onClick={onBack}
          >
            {t('login.passwordReset.returnToLogin')}
          </Button>
        )}
      </FormLayout.CTA>
    </>
  );
};
